module.exports = __webpack_public_path__ + "static/img/16.14134e3a.png";